import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TextEditor = ({ value = "", setFieldWithEditor }: any) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    console.log("Editor received value:", value); // 👈 ADD THIS LINE

    if (!initialized && value) {
      const blocksFromHtml = htmlToDraft(value);
      if (blocksFromHtml) {
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
      }
      setInitialized(true); 
    }
    // else {
    //   setEditorState(EditorState.createEmpty());
    // }
  }, [value, initialized]);

  const handleEditorChange = (newState: EditorState) => {
    setEditorState(newState);
    const html = draftToHtml(convertToRaw(newState.getCurrentContent()));
    if (setFieldWithEditor) {
      setFieldWithEditor(html);
    }
  };

  return (
    <div style={{ border: "1px solid #ccc", padding: "2px" }}>
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        editorStyle={{
          direction: "ltr",
          textAlign: "left",
          minHeight: "200px",
          padding: "10px",
        }}
        localization={{ locale: "en" }}
      />
    </div>
  );
};

export default TextEditor;
